module.exports = __webpack_public_path__ + "img/class3.b81bd0ce.png";